/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Enum for organization invitation status
 */
export var OrganizationInvitationStatusEnum;

(function (OrganizationInvitationStatusEnum) {
  OrganizationInvitationStatusEnum["PENDING"] = "pending";
  OrganizationInvitationStatusEnum["ACCEPTED"] = "accepted";
  OrganizationInvitationStatusEnum["FAILED"] = "failed";
  OrganizationInvitationStatusEnum["CANCELED"] = "canceled";
})(OrganizationInvitationStatusEnum || (OrganizationInvitationStatusEnum = {}));